<div class="card-container card">
  <div class="table-container">
    <table class="table mb-0">
      <thead [ngClass]="{ 'bg-secondary': loading }">
        <tr>
          <div class="card-header-title d-flex justify-content-between" style="background-color: #e7e6e6; padding-left: 14px">
            <div class="border" (click)="showRows()">
              <span class="card-title">{{ title }}</span>
              <pos-app-spinner2 *ngIf="loading"></pos-app-spinner2>
            </div>
            <div class="d-flex justify-content-end" style="padding-right: 14px">
              <span *ngIf="isAdminUser && isInternalUser && !loading && userEmailList.length > 0" (click)="viewEmailListToDelete()">
                <mat-icon>settings</mat-icon>
              </span>
              <span>
                <button class="'btn btn-primary text-uppercase">Go to communications</button>
              </span>
              <span>
                <mat-icon>keyboard_arrow_down</mat-icon>
              </span>
            </div>
          </div>
        </tr>
      </thead>
    </table>
    <div *ngIf="isShowRows">
      <div class="content-header">
        <div *ngFor="let item of paginateData; let i = index" (click)="showSelectedEmailDetails(item)">
          <div class="list-group-item" title="{{ item.subject }}">
            <div class="d-flex w-100">
              <span class="icon-container"><mat-icon style="height: 18px"> zoom_in </mat-icon></span>
              <span class="subject-container">{{ item.subject }}</span>
              <span class="date-container"> ({{ getFormatedDate(item.dateSent) }}) </span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="paginateData.length === 0">
        <div class="list-group-item">{{ showEmptyMessage }}</div>
      </div>
    </div>

    <div *ngIf="isShowRows" class="d-flex justify-content-end pagination-container">
      <ngb-pagination
        *ngIf="pageSize"
        class="d-flex justify-content-center"
        [collectionSize]="collectionSize"
        [maxSize]="6"
        [boundaryLinks]="true"
        [(page)]="page"
        [pageSize]="pageSize"
        (pageChange)="getPaginationData()"
      >
        <ng-template ngbPaginationFirst>|<</ng-template>
        <ng-template ngbPaginationPrevious><</ng-template>
        <ng-template ngbPaginationNext>></ng-template>
        <ng-template ngbPaginationLast>>|</ng-template>
        <div class="d-flex justify-content-end">
          <ngb-pagination
            [collectionSize]="userEmailList.length"
            [maxSize]="5"
            [boundaryLinks]="true"
            [(page)]="page"
            [pageSize]="pageSize"
            (pageChange)="getPaginationData()"
          >
            <ng-template ngbPaginationPages let-page let-pages="pages">
              <li class="ngb-custom-pages-item">
                <div class="d-flex flex-nowrap px-2">
                  <span id="paginationDescription" class="p-2" style="font-size: 10px"> Page {{ page }} of {{ pages.length }}</span>
                </div>
              </li>
            </ng-template>
          </ngb-pagination>
        </div>
      </ngb-pagination>
    </div>
  </div>

  <ng-template #emailDetailContent let-c="close" let-d="dismiss">
    <div class="modal-header row">
      <div class="col d-flex justify-content-start">
        <div class="d-flex justify-content-start">
          <h5>Subject : {{ userSeletedEmailDetailsData.subject }}</h5>
        </div>
      </div>
      <div class="d-flex justify-content-start">Date Sent : {{ userSeletedEmailDetailsData.dateSent }}</div>
      <div *ngIf="filteredAttachments.length > 0">
        <div class="d-flex justify-content-start">
          <div class="d-flex justify-content-start">Attachments:</div>
          <div class="d-flex">
            <a *ngFor="let attachment of filteredAttachments" (click)="downloadAttachment(attachment)" class="attachment-link">
              <mat-icon style="height: 20px">file_download</mat-icon>
              <span class="p-1">{{ attachment.filename }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-body email-detail-content-body">
      <div *ngIf="isShowUserEmailDetails">
        <div class="px-2" [innerHTML]="safeHtmlBody"></div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>

  <ng-template #emailListContent let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h3 class="arb-large-heading" id="modal-basic-title">{{ title }}</h3>
    </div>
    <div class="modal-body">
      <div class="col pt-2 mx-4">
        <div class="row">
          <div class="col-4 pb-2 w-20 d-flex justify-content-start">
            <input [readonly]="isAddingNewEmailBulletin" type="text" class="form-control" [(ngModel)]="searchValue" placeholder="Search..." />
          </div>
          <div class="col-4 pb-2 w-20 d-flex justify-content-start">
            <button class="btn" (click)="addNewEmailBulletin()" title="Add New Email Bulletin">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
                <path
                  d="M440-200h80v-167l64 64 56-57-160-160-160 160 57 56 63-63v167ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"
                /></svg
              >Add New Email Bulletin
            </button>
          </div>
        </div>

        <div *ngIf="isAddingNewEmailBulletin">
          <app-lib-user-email-new-bulletin-form
            [isAddingNewEmailBulletin]="isAddingNewEmailBulletin"
            [isEditingEmailBulletin]="isEditingEmailBulletin"
            (updateEmailBulletin)="updateEmailBulletin($event)"
            (createNewEmailBulletin)="createNewEmailBulletin($event)"
            (closeAddingEmailBulletin)="closeAddingEmailBulletin($event)"
          ></app-lib-user-email-new-bulletin-form>
        </div>
        <div *ngIf="!isAddingNewEmailBulletin">
          <ag-grid-angular
            #agGrid
            class="ag-theme-balham datagrid"
            [rowData]="rowData"
            [context]="context"
            [frameworkComponents]="frameworkComponents"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            [domLayout]="'autoHeight'"
            [pagination]="true"
            [paginationPageSize]="15"
            [quickFilterText]="searchValue"
          ></ag-grid-angular>
        </div>
        <div></div>
      </div>
    </div>
    <div *ngIf="!isAddingNewEmailBulletin" class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>
</div>
